import { Box, Typography } from '@mui/material';
import AccountCard from '../components/AccountCard';

import { useAccountDataContext } from '../AccountData';

export const Profile = () => {
    const { data } = useAccountDataContext();

    return (
        <Box
            sx={{
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                height: '100%',
                py: 4,
                boxSizing: 'border-box',
            }}
        >
            <Typography variant="h4" fontSize={20} mb={2}>
                Company's Primary Contact
            </Typography>
            <AccountCard companyProfile={data?.company} />
        </Box>
    );
};
